var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"main-container"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"userBriefHistory",class:_vm.$vuetify.theme.dark ? 'transparent ' : 'white-lighten-2',attrs:{"tile":"","flat":""}},[_c('partner-tabs')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }